import React from 'react'
import './PaygeItem.css'
import logo from '../../assets/img/logo.png'
import upiLogo from '../../assets/img/upi-icon.png'
import paygeCodeLogo from '../../assets/img/payge-code.png'
import { InsertDriveFile, GetApp, ArrowDownward, ArrowForward, CheckCircle, CheckBoxRounded, RadioButtonUnchecked, DoneAll, Payment, AccountBalance, AccountBalanceWallet, ArrowBack, Done, GetAppRounded, Lock, AttachMoney, Close, Cached, Add } from '@material-ui/icons'
import { API_URL } from '../../config'

import axios from 'axios'
import Modal from 'react-modal'
import CreditCardInput from 'react-credit-card-input'
import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js'
import OtpInput from 'react-otp-input';

let dummy_des = "A native macOS app for your favourite Google Calendar website converted into native macOS app using electron and nativefier for easy access."
let dummy_file = "ZIP file — 40.56 MB"

// returns formatted file size
function formatBytes(a,b=2) {if(0===a)return"0 Bytes";const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return parseFloat((a/Math.pow(1024,d)).toFixed(c))+" "+["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]}

// Razorpay setup
var razorpay = new window.Razorpay({
  key: 'rzp_test_D6DAt2QAAumov7',
    // logo, displayed in the payment processing popup
  image: 'https://payge-assets.s3.amazonaws.com/rounded.png',
})

export default class PaygeItem extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isDownloading: false,
      downloadingPercent: 0,
      paymentCard: {number: undefined, expiry: undefined, cvc: undefined},
      isCardValid: false,
      isEmailFlowOpen: true,
      isPurchaseOtpFlowOpen: false,
      isEmailFlowLoading: false,
      isPaymentModalOpen: false,
      paymentEmail: undefined,
      paymentName: undefined,
      paymentPhone: undefined,
      activeOrder: undefined,
      isPaymentInfoNotValid: false,
      isNameValid: true,
      isPhoneValid: true,
      isUpiSelected: false,
      isGettingFile: false,
      purchaseOtp: undefined,
      isDownloaded: false,
    }
  }

  // downloading from Dropbox
  downloadDropboxFile = (dropboxFile, paygeId) => {
    if (dropboxFile.id) {
      // dropbox file id
      let dropboxPathObj = {path: dropboxFile.id}
      // file details
      let file = {
        name: dropboxFile.name,
        size: dropboxFile.bytes,
      }
      // request details
      let request = {
        url: 'https://content.dropboxapi.com/2/files/download',
        headers: {
          'Authorization': 'Bearer YybfD17pZlAAAAAAAAAAd9jvpUkY7MKzxx96ux-Nl4G-LjwK0dGLi8cUunrW5GiU',
          'Dropbox-API-Arg': JSON.stringify(dropboxPathObj)
        },
        method: 'POST'
      }

      // getting download file with stream
      this.downloadFileWithStream(request, file, paygeId)
    }
  }
  // downloading from Google Drive
  downloadGoogleDriveFile = (driveFile, paygeId) => {
    if (driveFile) {
      // file details
      let fileName = driveFile.originalFilename
      if (!fileName.endsWith(`.${driveFile.fileExtension}`)) {
        fileName += `.${driveFile.fileExtension}`
      }
      let file = {
        name: fileName,
        size: driveFile.fileSize,
      }
      // request details
      let request = {
        url: driveFile.downloadUrl,
        headers: {},
        method: 'GET'
      }

      // getting download file with stream
      this.downloadFileWithStream(request, file, paygeId)
    }
  }
  // download the current file
  startFileDownload = (driveFile, dropboxFile, paygeId) => {
    if (driveFile) {
      this.downloadGoogleDriveFile(driveFile, paygeId)
    } else if (dropboxFile) {
      this.downloadDropboxFile(dropboxFile, paygeId)
    }
  }

  // function to download file in stream
  downloadFileWithStream = (request, file, paygeId) => {
    const self = this
    // file
    let fileName = file.name
    let fileSize = file.size
    // request
    let url = request.url
    let headers = request.headers
    let method = request.method

    this.setState({
      isDownloading: true,
      downloadingPercent: 0,
      isGettingFile: true,
    })

    // getting download file with stream
    fetch(url, {
      method: method,
      headers: headers
    }).then(response => {
      // Calling getReader() gives us exclusive access to the stream's content
      var reader = response.body.getReader()
      var bytesReceived = 0
      self.setState({isGettingFile: false})

      return new ReadableStream({
        start(controller) {
          return pump()
          function pump() {
            return reader.read().then(({ done, value }) => {
              // When no more data needs to be consumed, close the stream
              if (done) {
                self.setState({
                  downloadingPercent: 100,
                  isDownloading: false,
                  isDownloaded: true,
                })
                controller.close()
                return
              }
              // result.value for fetch streams is a Uint8Array
              bytesReceived += value.length;
              let downloadPercent = Math.floor((bytesReceived / fileSize) * 100)
              self.setState({downloadingPercent: downloadPercent})
              // Enqueue the next data chunk into our target stream
              controller.enqueue(value);
              return pump()
            })
          }
        }  
      })

    })
    .then(stream => new Response(stream))
    .then(response => response.blob())
    .then(blob => {
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url;
      link.setAttribute('download', fileName)
      // Append to html page and force click
      document.body.appendChild(link)
      link.click()
      // Clean up and remove the link
      link.parentNode.removeChild(link)

      // adding download to db
      this.triggerDownload(paygeId)
    })
    .catch(err => console.error(err))
  }

  // triggering download API call
  triggerDownload = (paygeId) => {
    if (paygeId) {
      let url = `${API_URL}/payge/${paygeId}/download`
      axios({
        method: 'POST',
        url: url,
        headers: {
          'Authorization': 'payge-web-token-2052020'
        }
      })
    }
  }

  // payment methods 

  // handling functions for card input 
  handleCardNumberChange = (e) => {
    let paymentCard = this.state.paymentCard
    paymentCard.number = e.target.value
    this.setState({paymentCard: paymentCard, isCardValid: true})
  }
  handleCardExpiryChange = (e) => {
    let paymentCard = this.state.paymentCard
    paymentCard.expiry = e.target.value
    this.setState({paymentCard: paymentCard, isCardValid: true})
  }
  handleCardCVCChange = (e) => {
    let paymentCard = this.state.paymentCard
    paymentCard.cvc = e.target.value
    this.setState({paymentCard: paymentCard, isCardValid: true})
  }
  handleCardInfoError = () => {
    this.setState({isCardValid: false})
  }

  openPaymentDialog = (isPaid, driveFile, dropboxFile, paygeId) => {
    if (isPaid) {
      this.setState({isPaymentModalOpen: true})
    } else {
      this.startFileDownload(driveFile, dropboxFile, paygeId)
    }
  }
  closePaymentDialog = () => {
    this.setState({isPaymentModalOpen: false})
  }
  // get email and create order
  proceedToPayWithEmail = (paymentDetails) => {
    const { paymentEmail } = this.state
    const { paygeId } = this.props
    // checking for valid values
    if (!this.validateEmail(paymentEmail)) {
      this.setState({isPaymentInfoNotValid: true})
      setTimeout(() => {
        this.setState({isPaymentInfoNotValid: false})
      }, 2000)
      return
    }
    this.setState({isEmailFlowLoading: true})

    // sending request to create new request
    console.log(paymentDetails.currency)
    axios({
      method: 'POST',
      url: `${API_URL}/payge/${paygeId}/payment/new`,
      headers: { 'Content-Type': 'application/json' },
      data: { 
        amount: paymentDetails.amount,
        currency: paymentDetails.currency,
        email: paymentEmail 
      }
    })
      .then((result) => {
        if (result.status === 200) {
          if (result.data.status === "success") {
            this.setState({isEmailFlowOpen: false, activeOrder: result.data, isEmailFlowLoading: false})
          } else if (result.data.status === "purchased") {
            this.setState({activeOrder: undefined, isEmailFlowLoading: false, isPurchaseOtpFlowOpen: true})
          } else {
            this.setState({activeOrder: undefined, isEmailFlowLoading: false})
          }
        }
      },
      (error) => {
        this.setState({activeOrder: undefined, isEmailFlowLoading: false})
      })
  }
  // starting payment
  startPayment = () => {
    let { activeOrder, paymentCard, paymentName, paymentPhone, isCardValid, isNameValid, isUpiSelected } = this.state
    const { paygeId, driveFile, dropboxFile } = this.props
    const self = this
    
    // checking for valid values
    let parsedNumber = parsePhoneNumberFromString(paymentPhone)
    let isPhoneValid = parsedNumber ? parsedNumber.isValid() : false

    if (!activeOrder || (!paymentName || paymentName.trim() === "") || 
      !isPhoneValid || (!isCardValid && !isUpiSelected)) {

      this.setState({isPaymentInfoNotValid: true})
      setTimeout(() => {
        this.setState({isPaymentInfoNotValid: false})
      }, 2000)
      // setting correct errors
      if (!paymentName || paymentName.trim() === "") {
        isNameValid = false
      }
      this.setState({isNameValid: isNameValid, isPhoneValid: isPhoneValid})
      return
    }

    // creating rzrpay data
    var data = {
      amount: activeOrder.order.amount,
      currency: activeOrder.order.currency,
      contact: paymentPhone,
      email: activeOrder.order.email,
      notes: activeOrder.order.notes,
      order_id: activeOrder.order.razorpayOrderId,
      method: isUpiSelected ? 'upi' : 'card',
    }
    if (!isUpiSelected) {
      data.card = {
        number: Number(paymentCard.number.replace(/\s/g,'')),
        name: paymentName,
        expiry_month: Number(paymentCard.expiry.split('/')[0]),
        expiry_year: Number(paymentCard.expiry.split('/')[1]),
        cvv: Number(paymentCard.cvc)
      }
    }

    // starting payment
    razorpay.createPayment(data);

    razorpay.on('payment.success', function(resp) {
      // verifying payment
      axios({
        method: 'POST',
        url: `${API_URL}/payge/${paygeId}/payment/verify`,
        headers: { 'Content-Type': 'application/json' },
        data: { 
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature,
          name: paymentName,
          phone: paymentPhone
        }
      })
      // start the download here
      self.startFileDownload(driveFile, dropboxFile, paygeId)
      self.closePaymentDialog()
    })

    razorpay.on('payment.error', function(resp) {alert(resp.error.description)})
  }
  // validate otp
  validateOtpAndDownload = () => {
    const { purchaseOtp, paymentEmail } = this.state
    const { paygeId, driveFile, dropboxFile } = this.props
    this.setState({isEmailFlowLoading: true})
    axios({
      method: 'POST',
      url: `${API_URL}/payge/${paygeId}/payment/otp`,
      headers: { 'Content-Type': 'application/json' },
      data: { 
        otp: purchaseOtp,
        ownerEmail: paymentEmail
      }
    })
      .then((result) => {
        if (result.status === 200) {
          if (result.data.status === "success") {
            // downloading file
            this.startFileDownload(driveFile, dropboxFile, paygeId)
            // closing modal
            this.setState({isEmailFlowOpen: true, isPurchaseOtpFlowOpen: false, isEmailFlowLoading: false, isPaymentModalOpen: false})
          } else {
            this.setState({isPaymentInfoNotValid: true, isEmailFlowLoading: false})
            setTimeout(() => {
              this.setState({isPaymentInfoNotValid: false})
            }, 2500)
          }
        }
      },
      (error) => {
        this.setState({isPaymentInfoNotValid: true, isEmailFlowLoading: false})
        setTimeout(() => {
          this.setState({isPaymentInfoNotValid: false})
        }, 2500)
      })
  }

  validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  handlePhoneNumberChange = (e) => {
    let value = e.target.value
    if (!value.startsWith('+')) {
      value = '+' + value
    }
    this.setState({paymentPhone: new AsYouType().input(value), isPhoneValid: true})
  }
  handlePurchaseOtpChange = (e) => {
    let value = e.target.value
    if (value.length < 6) {
      this.setState({purchaseOtp: value})
    }
  }

  render() {
    let { theme, name, description, driveFile, dropboxFile, isLoaded, paygeId, isDemo, isPaid, paymentDetails, background,
      isEditing, fileNameInput, isBackgroundLoaded } = this.props
    const { isDownloading, downloadingPercent, paymentCard, isEmailFlowOpen, isPaymentModalOpen, isUpiSelected, isGettingFile,
      paymentEmail, paymentName, paymentPhone, isPaymentInfoNotValid, isNameValid, isPhoneValid, isEmailFlowLoading, purchaseOtp,
      isPurchaseOtpFlowOpen, isDownloaded } = this.state

    // placeholder values
    if (name === undefined || name.trim() === "") {
      name = "Your Download Name"
    }
    if (description === undefined || name.trim() === "") {
      description = "Description for the download goes here"
    }

    // getting File Info
    let file_info = undefined
    let fileDownloadLink = '#'
    let fileName = 'Downloaded from Payge.io'
    // getting dropbox file data
    if (dropboxFile) {
      fileName = dropboxFile.name
      let fileSize = formatBytes(dropboxFile.bytes)
      let nameDotSplit = fileName.split('.')
      let fileExtension = nameDotSplit[nameDotSplit.length-1]
      file_info = `${fileExtension.toUpperCase()} file — ${fileSize}`
      // getting the file link
      fileDownloadLink = `${dropboxFile.link}`
    }
    // getting drive file data
    if (driveFile) {
      let fileSize = formatBytes(driveFile.fileSize)
      file_info = `${driveFile.fileExtension.toUpperCase()} file — ${fileSize}`
      fileName = driveFile.title
      // getting the file link
      fileDownloadLink = `${driveFile.downloadUrl}`
    }
    if (file_info === undefined || file_info.trim() === "") {
      file_info = "Add file link"
    }
    // getting price data
    let price = 'Free'
    if (paymentDetails) {
      let currencyText = "₹"
      if (paymentDetails.currency === 'USD') {
        currencyText = "$"
      }
      price = `${currencyText}${paymentDetails.amount/100}` 
    }

    // getting download percent
    let indicatorPercent = downloadingPercent
    if (downloadingPercent < 2) {
      if (isGettingFile) { indicatorPercent = 1 }
      else { indicatorPercent = 2 }
    }

    // theme styling
    let container_styles = 'container-one'
    switch (theme) {
      case 'one':
        container_styles = 'container-one'
        break
      case 'two':
        container_styles = 'container-two'
        break
      case 'three':
        container_styles = 'container-three'
        break
      case 'four':
        container_styles = 'container-four'
        break
    }
    container_styles += isEditing ? ' nopadding-bottom' : ''
 
    // download element
    let downloadButtonElement = (
      <>
        <span>{isPaid ? "Pay & Download" : "Download"}</span>
        <ArrowDownward className="icon big" />
      </>
    )
    // downloadButtonElement = (
    //   <>
    //     <span><Lock className="icon" />Download</span>
    //     <span className="price code">Invite Code</span>
    //   </>
    // )

    return (
      <>
        <section className={container_styles}>
          {
            !isLoaded ? (
              <>
                <div class="shimmer-container">
                  <div className="name shimmer" />
                  <div className="description shimmer" />
                  <div className="description shimmer" />
                  <div className="description shimmer short" />
                  <br/>
                  <div className="button shimmer" />
                </div>
              </>
            ) : (
              <>
                {
                  theme === 'four' ? (
                    <>
                      <img src={isBackgroundLoaded || isEditing ? background.urls.small : background.urls.thumb} className="download-top-img"/>
                      {
                        !this.props.isBackgroundChooserOpen && isEditing ? (
                          <div className="add-image-container" onClick={this.props.onChangeBackground}>
                            <Cached className="icon" />
                            Click to Change Image
                          </div>
                        ) : false
                      }
                    </>
                  ): false
                } 
                <div className="download-content">
                  {
                    isEditing ? (
                      <div 
                        className={ this.props.isPublishError ? "title error" : "title"} 
                        placeholder="Add file name..." 
                        contentEditable
                        onInput={(e)=>this.props.onFileNameChange(e.target.textContent)} >
                        {/* {fileNameInput} */}
                      </div>
                    ) : (
                      <span className="title">{name}</span>
                    )
                  }
                  <span className="description">{description}</span>

                  <div className="file-info-container">
                    <InsertDriveFile className="icon" />
                    <span className="text">{file_info}</span>
                  </div>

                  {
                    isPaid ? (
                      <div className="download-price-container">
                        <span className="price-title">{price}</span>
                        <span className="price-text">price for download</span>
                      </div>
                    ) : false
                  }

                  {
                    (driveFile || dropboxFile) && !isDownloading && !isDemo && !isDownloaded ? (
                      <div className="download-btn" onClick={()=>this.openPaymentDialog(isPaid, driveFile, dropboxFile, paygeId)}>
                        {downloadButtonElement}
                      </div>
                    ) : (dropboxFile || driveFile) && isDownloading && !isDemo && !isDownloaded ? (
                      <div className="loading-container">
                        <div className="info">
                          <span className="downloading-text">
                            {`${isGettingFile ? 'Fetching': 'Downloading'} your file...`}
                          </span>
                          <span className="percent-text">{`${downloadingPercent}%`}</span>
                        </div>
                        <div className="progress-item">
                          <div className="progress-background" />
                          <div className="progress-meter" style={{width: `${indicatorPercent}%`}}/>
                        </div>
                      </div>
                    ) : isDownloaded ? (
                      <div className="download-completed-container">
                        <CheckCircle className="icon" />
                        <span>Download Completed</span>
                      </div>
                    ) : isDemo ? (
                      <div className="download-btn">
                        {downloadButtonElement}
                      </div>
                    ) : false
                  }
                  
                </div>
              </>
            )
          }

          <div className="powered-by" >
            <span className="text">Powered by</span>
            <a href={`https://payge.io/?utm_source=payge&utm_medium=download_page&utm_campaign=${paygeId}`} target="_blank">
              <div className="logo-container">
                <img src={logo} id="logo-icon" />
                <span className="logo-title">Payge</span>
              </div>
            </a>
          </div>

          {
            isEditing && isLoaded ? (
              <div className="remove-file-btn" onClick={this.props.onDownloadFileChange}>
                <Cached className="icon"/>Tap here if you want to change the download file
              </div>
            ): false
          }
        </section>

        <Modal
					isOpen={isPaymentModalOpen}
					ariaHideApp={false}
          contentLabel="Payment"
          className="pay-modal"
          onRequestClose={this.closePaymentDialog.bind(this)}
					shouldCloseOnOverlayClick={true}
          style={{
            overlay: {
              backgroundColor: 'rgb(255, 255, 255, 0.96)'
            }
          }}
					id="payment-modal">
					<>
            <div 
              className="pay-container">
              {
                isEmailFlowOpen && isEmailFlowLoading ? (
                  <>
                    <div class="shimmer-container" style={{padding: '25px 30px'}}>
                      <div className="description shimmer short" />
                      <div className="description shimmer" />
                      <br/>
                      <div className="description shimmer" />
                      <br/>
                      <div className="name shimmer" style={{alignSelf: 'flex-end'}} />
                    </div>
                  </>
                ) : isEmailFlowOpen && !isPurchaseOtpFlowOpen ? (
                  <div className="email-container">
                    <span className="pay-title">Tell us your email</span>
                    <span className="pay-description">We take your email to make sure that you haven't purchased the same download file before, if you have we will send you an email with a link to the downloadable file.</span>
                    <input 
                      type="text" 
                      className="email-input" 
                      placeholder="example@payge.io"
                      value={paymentEmail}
                      onChange={(e)=>this.setState({paymentEmail: e.target.value})} />
                    <div className={ isPaymentInfoNotValid ? "action-btn error":"action-btn"} onClick={()=>this.proceedToPayWithEmail(paymentDetails)}>
                      Proceed to Payment<ArrowForward className="icon"/>
                    </div>
                  </div>
                ) : isPurchaseOtpFlowOpen ? (
                  <div className="email-container">
                    <div className="pay-title-holder" style={{display: 'flex', flexDirection: 'column'}}>
                      <ArrowBack className="pay-back-icon" onClick={()=>this.setState({isEmailFlowOpen: true, isPurchaseOtpFlowOpen: false})} />
                      <span className="pay-title" style={{marginTop: 16}}>Good news, you've already purchased this download!</span>
                    </div>
                    <span className="pay-description">
                      Seems like you've purchased this download before. For downloading again, we have sent you an OTP to your email <b>{paymentEmail}</b>, enter the OTP below to download the file!
                    </span>
                    <div className="otp-input">
                      <OtpInput
                        onChange={otp => this.setState({purchaseOtp: otp})}
                        numInputs={5}
                        value={purchaseOtp}
                        separator={<span>&nbsp;&nbsp;&nbsp;</span>} />
                    </div>
                    <div className={ isPaymentInfoNotValid ? "action-btn error":"action-btn"} onClick={this.validateOtpAndDownload}>
                      Download File<DoneAll className="icon"/>
                    </div>
                  </div>
                ): (
                  <div className="payment-container">
                    <div className="pay-title-holder">
                      <ArrowBack className="pay-back-icon" onClick={()=>this.setState({isEmailFlowOpen: true, isPurchaseOtpFlowOpen: false})} />
                      <span className="pay-title">Pay <span className="price">{price}</span></span>
                    </div>
                    <span className="pay-description">You'll be charged only <b className="price">{price}</b> and once the payment is completed you will be able to download the file.</span>

                    <span className="card-title">Payer Details</span>
                    <div className="info-input-container">
                      <input 
                        type="text" 
                        className={ isNameValid ? "info-input": "info-input error"} 
                        placeholder="Full Name"
                        value={paymentName}
                        onChange={(e)=>this.setState({paymentName: e.target.value, isNameValid: true})} />
                      <input 
                        type="text" 
                        className={ isPhoneValid ? "info-input": "info-input error"}
                        placeholder="Phone Number"
                        value={paymentPhone}
                        onChange={(e)=>this.handlePhoneNumberChange(e)} />
                    </div>

                    {
                      !isUpiSelected ? (<>
                        <span className="card-title">Credit & Debit cards</span>
                        <div className="card-form" onClick={()=>{if(isUpiSelected){this.setState({isUpiSelected: false})}}}>
                          <CreditCardInput
                            cardNumberInputProps={{ value: paymentCard.number, onChange: this.handleCardNumberChange}}
                            cardExpiryInputProps={{ value: paymentCard.expiry, onChange: this.handleCardExpiryChange }}
                            cardCVCInputProps={{ value: paymentCard.cvc, onChange: this.handleCardCVCChange  }}
                            fieldClassName="card-input"
                            onError={this.handleCardInfoError} />
                          {/* <CheckCircle className="icon"/> */}
                        </div>
                      </>) : false
                    }

                    {
                      paymentDetails.currency === 'INR' ? (<>
                        <span className="card-title upi-title">Other methods</span>
                        <ul className="other-methods">
                          <li 
                            className={isUpiSelected ? "selected": "unselected"}
                            onClick={()=>this.setState({isUpiSelected: isUpiSelected ? false : true})}><img src={upiLogo} /></li>
                          <li 
                            className={"inactive"}><img src={paygeCodeLogo} /></li>
                        </ul>
                      </>) : false
                    }

                    <div className={ isPaymentInfoNotValid ? "action-btn main error":"action-btn main"} onClick={this.startPayment.bind(this)}>
                      Pay & Download<Payment className="icon"/>
                    </div>
                  </div>
                )
              }
            </div>
          </>
				</Modal>

        <Modal
					isOpen={false}
					ariaHideApp={false}
          contentLabel="Payment"
          className="pay-modal"
          onRequestClose={this.closePaymentDialog.bind(this)}
          shouldCloseOnOverlayClick={true}
          style={{
            overlay: {
              backgroundColor: 'rgb(255, 255, 255, 0.96)'
            }
          }}
					id="payment-modal">
					<>
            <div 
              className="pay-container">
              {
                isEmailFlowOpen && isEmailFlowLoading ? (
                  <>
                    <div class="shimmer-container" style={{padding: '25px 30px'}}>
                      <div className="description shimmer short" />
                      <div className="description shimmer" />
                      <br/>
                      <div className="description shimmer" />
                      <br/>
                      <div className="name shimmer" style={{alignSelf: 'flex-end'}} />
                    </div>
                  </>
                ) : isEmailFlowOpen && !isPurchaseOtpFlowOpen ? (
                  <div className="email-container">
                    <span className="pay-title">Enter your invite code!</span>
                    <span className="pay-description">Use the invite code provided by the download payge creator to download the file.</span>
                    <input 
                      type="text" 
                      className="code-input" 
                      placeholder="eg. PAYGEINVITE2020"
                      value={paymentEmail}
                      onChange={(e)=>this.setState({paymentEmail: e.target.value})} />
                    <div className={ isPaymentInfoNotValid ? "action-btn error":"action-btn"} onClick={()=>this.proceedToPayWithEmail(paymentDetails)}>
                      Get Download<ArrowForward className="icon"/>
                    </div>
                  </div>
                ) : false
              }
            </div>
          </>
				</Modal>
      </>
    )
  }

}